/**
 * @pageName Services
 * @slotType dashboard plugin
 */
export type ServicesBannerParams = {};
/**
 * @pageName Services
 * @slotType dashboard menu plugin
 */
export type ServicesMainActionsMenuParams = {};
/**
 * @pageName Services
 * @slotType dashboard menu plugin
 */
export type ServiceItemMoreActionsMenuParams = {
  /* Service ID.*/ serviceId: string;
};
